import React from 'react';
import Icon from '@mui/material/Icon';

/**
 * Convert PascalCase MUI icon name to Material Icons ligature (snake_case).
 * e.g. "WaterDrop" → "water_drop", "ElectricBolt" → "electric_bolt"
 */
function toLigature(name) {
    if (!name) return 'help_outline';
    return name
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
        .toLowerCase();
}

/**
 * Get a React icon element from an icon name string (PascalCase MUI name from DB).
 * Uses MUI Icon component with Material Icons web font — supports ALL icons
 * without needing individual imports.
 *
 * @param {string} iconName - Icon name from DB (e.g. "WaterDrop", "ElectricBolt")
 * @param {object} props - Props to pass to the Icon component (sx, fontSize, color, etc.)
 * @returns {React.ReactElement}
 */
export function getIcon(iconName, props = {}) {
    const ligature = toLigature(iconName);
    return <Icon {...props}>{ligature}</Icon>;
}

/**
 * Check if icon name is provided (non-empty).
 * With the font approach, any valid Material Icon name will render.
 * @param {string} iconName
 * @returns {boolean}
 */
export function hasIcon(iconName) {
    return !!iconName && iconName.length > 0;
}

export default { getIcon, hasIcon };
